import { useCallback, useState } from 'react';
import { useGetChatSessionsSupervisorInprogressQuery } from 'services';
import { FindAllChatSessionsHistoryDto, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useOmniChatSessionSupervisorInprogressList(
  params: Omit<FindAllChatSessionsHistoryDto, 'skip' | 'limit'>,
  options?: UseQueryOptionsType
) {
  const { keyword, isHandleByAi, source, endpoint } = params;

  const [skip, setSkip] = useState(0);

  const {
    data: dataResponse,
    isLoading,
    isFetching,
    refetch,
    endpointName
  } = useGetChatSessionsSupervisorInprogressQuery(
    {
      skip,
      limit: pageSize,
      keyword,
      isHandleByAi,
      source,
      endpoint
    },
    {
      ...options
    }
  );

  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);

  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      setSkip(rows?.length ?? 0);
    }
  }, [hasMore, skip, isFetching]);

  const resetPage = () => {
    setSkip(0);
  };

  return {
    chatSessionSupervisorOngoing: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage,
    refetch
  };
}
